// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddBlogs_container__MZ101 {
  min-height: 100vh;
  background-color: #000000;
  color: #ffffff;
  padding: 2rem;
}

.AddBlogs_formWrapper__jh0Of {
  max-width: 1200px;
  margin: 0 auto;
  background-color: #111111;
  border-radius: 8px;
  padding: 2rem;
  box-shadow: 0 0 20px rgba(255, 0, 0, 0.1);
}

.AddBlogs_title__fsHkc {
  color: white;
  font-size: 2.5rem;
  margin-bottom: 2rem;
  text-align: center;
}

.AddBlogs_form__xXBeI {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.AddBlogs_inputGroup__m8iHA {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.AddBlogs_inputGroup__m8iHA label {
  color: white;
  font-size: 1rem;
  font-weight: 600;
}

.AddBlogs_inputGroup__m8iHA input,
.AddBlogs_inputGroup__m8iHA select,
.AddBlogs_inputGroup__m8iHA textarea {
  padding: 0.75rem;
  border-radius: 4px;
  border: 1px solid #333333;
  background-color: #222222;
  color: #ffffff;
  font-size: 1rem;
}

.AddBlogs_inputGroup__m8iHA input:focus,
.AddBlogs_inputGroup__m8iHA select:focus,
.AddBlogs_inputGroup__m8iHA textarea:focus {
  outline: none;
  border-color: white;
  box-shadow: 0 0 0 2px rgba(255, 0, 0, 0.2);
}

.AddBlogs_joditWrapper__XV97o {
  margin-bottom: 1rem;
}

/* Jodit Editor dark theme overrides */
.jodit-container:not(.jodit-inline) {
  border-color: #333333 !important;
  border-radius: 4px !important;
}

.jodit-workplace {
  background-color: #222222 !important;
}

.jodit-toolbar__box {
  background-color: #333333 !important;
  border-bottom: 1px solid #444444 !important;
}

.jodit-toolbar-button {
  color: #ffffff !important;
}

.jodit-toolbar-button:hover:not([disabled]) {
  background-color: #444444 !important;
}

.jodit-status-bar {
  background-color: #333333 !important;
  border-top: 1px solid #444444 !important;
}

.jodit-ui-group_separated {
  border-color: #444444 !important;
}

.AddBlogs_seoSection__5D6kK {
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid #333333;
}

.AddBlogs_seoSection__5D6kK h2 {
  color: #ff0000;
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
}

.AddBlogs_submitButton__CHNQB {
  background-color: #ff0000;
  color: #ffffff;
  padding: 1rem 2rem;
  border: none;
  border-radius: 4px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
  margin-top: 2rem;
}

.AddBlogs_submitButton__CHNQB:hover {
  background-color: #cc0000;
}

.AddBlogs_inputGroup__m8iHA textarea {
  min-height: 100px;
  resize: vertical;
}

.AddBlogs_imageUploadContainer__-I-t1 {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.AddBlogs_fileInput__ub34G {
  display: none;
}

.AddBlogs_uploadButton__R544n {
  background-color: #333333;
  color: #ffffff;
  padding: 0.75rem 1.5rem;
  border: 2px dashed #ff0000;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  width: fit-content;
}

.AddBlogs_uploadButton__R544n:hover {
  background-color: #444444;
  border-color: #ff3333;
}

.AddBlogs_imagePreviewContainer__Q7Y2- {
  margin-top: 1rem;
  max-width: 400px;
  border-radius: 4px;
  overflow: hidden;
  border: 2px solid #333333;
}

.AddBlogs_imagePreview__RgAmK {
  width: 100%;
  height: auto;
  display: block;
}
.AddBlogs_errorInput__WgzO9 {
  border-color: #ff4444;
}

.AddBlogs_errorMessage__qLe0N {
  color: #ff4444;
  font-size: 0.875rem;
  margin-top: 0.25rem;
}`, "",{"version":3,"sources":["webpack://./src/admin/pages/Add Blogs/AddBlogs.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB","sourcesContent":[".container {\n  min-height: 100vh;\n  background-color: #000000;\n  color: #ffffff;\n  padding: 2rem;\n}\n\n.formWrapper {\n  max-width: 1200px;\n  margin: 0 auto;\n  background-color: #111111;\n  border-radius: 8px;\n  padding: 2rem;\n  box-shadow: 0 0 20px rgba(255, 0, 0, 0.1);\n}\n\n.title {\n  color: white;\n  font-size: 2.5rem;\n  margin-bottom: 2rem;\n  text-align: center;\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.inputGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.inputGroup label {\n  color: white;\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.inputGroup input,\n.inputGroup select,\n.inputGroup textarea {\n  padding: 0.75rem;\n  border-radius: 4px;\n  border: 1px solid #333333;\n  background-color: #222222;\n  color: #ffffff;\n  font-size: 1rem;\n}\n\n.inputGroup input:focus,\n.inputGroup select:focus,\n.inputGroup textarea:focus {\n  outline: none;\n  border-color: white;\n  box-shadow: 0 0 0 2px rgba(255, 0, 0, 0.2);\n}\n\n.joditWrapper {\n  margin-bottom: 1rem;\n}\n\n/* Jodit Editor dark theme overrides */\n:global(.jodit-container:not(.jodit-inline)) {\n  border-color: #333333 !important;\n  border-radius: 4px !important;\n}\n\n:global(.jodit-workplace) {\n  background-color: #222222 !important;\n}\n\n:global(.jodit-toolbar__box) {\n  background-color: #333333 !important;\n  border-bottom: 1px solid #444444 !important;\n}\n\n:global(.jodit-toolbar-button) {\n  color: #ffffff !important;\n}\n\n:global(.jodit-toolbar-button:hover:not([disabled])) {\n  background-color: #444444 !important;\n}\n\n:global(.jodit-status-bar) {\n  background-color: #333333 !important;\n  border-top: 1px solid #444444 !important;\n}\n\n:global(.jodit-ui-group_separated) {\n  border-color: #444444 !important;\n}\n\n.seoSection {\n  margin-top: 2rem;\n  padding-top: 2rem;\n  border-top: 1px solid #333333;\n}\n\n.seoSection h2 {\n  color: #ff0000;\n  font-size: 1.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.submitButton {\n  background-color: #ff0000;\n  color: #ffffff;\n  padding: 1rem 2rem;\n  border: none;\n  border-radius: 4px;\n  font-size: 1.1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  margin-top: 2rem;\n}\n\n.submitButton:hover {\n  background-color: #cc0000;\n}\n\n.inputGroup textarea {\n  min-height: 100px;\n  resize: vertical;\n}\n\n.imageUploadContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.fileInput {\n  display: none;\n}\n\n.uploadButton {\n  background-color: #333333;\n  color: #ffffff;\n  padding: 0.75rem 1.5rem;\n  border: 2px dashed #ff0000;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  width: fit-content;\n}\n\n.uploadButton:hover {\n  background-color: #444444;\n  border-color: #ff3333;\n}\n\n.imagePreviewContainer {\n  margin-top: 1rem;\n  max-width: 400px;\n  border-radius: 4px;\n  overflow: hidden;\n  border: 2px solid #333333;\n}\n\n.imagePreview {\n  width: 100%;\n  height: auto;\n  display: block;\n}\n.errorInput {\n  border-color: #ff4444;\n}\n\n.errorMessage {\n  color: #ff4444;\n  font-size: 0.875rem;\n  margin-top: 0.25rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AddBlogs_container__MZ101`,
	"formWrapper": `AddBlogs_formWrapper__jh0Of`,
	"title": `AddBlogs_title__fsHkc`,
	"form": `AddBlogs_form__xXBeI`,
	"inputGroup": `AddBlogs_inputGroup__m8iHA`,
	"joditWrapper": `AddBlogs_joditWrapper__XV97o`,
	"seoSection": `AddBlogs_seoSection__5D6kK`,
	"submitButton": `AddBlogs_submitButton__CHNQB`,
	"imageUploadContainer": `AddBlogs_imageUploadContainer__-I-t1`,
	"fileInput": `AddBlogs_fileInput__ub34G`,
	"uploadButton": `AddBlogs_uploadButton__R544n`,
	"imagePreviewContainer": `AddBlogs_imagePreviewContainer__Q7Y2-`,
	"imagePreview": `AddBlogs_imagePreview__RgAmK`,
	"errorInput": `AddBlogs_errorInput__WgzO9`,
	"errorMessage": `AddBlogs_errorMessage__qLe0N`
};
export default ___CSS_LOADER_EXPORT___;
